<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table">
      <tr class="title p-1 w-full">
        <th colspan="3">CONDUTOR PRINCIPAL</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Condutor é o segurado?</b>:
          {{
            proposalData.dadosCliente.cpf === proposalData.driver.taxId
              ? 'Sim'
              : 'Não'
          }}
        </td>
        <td class="pl-3">
          <b>{{
            getNameLabel(
              proposalData.driver.taxId,
              proposalData.driver.socialName,
            )
          }}</b
          >:
          {{ proposalData.driver.name }}
        </td>
        <td v-if="!quotationData.driver.social_name" class="pl-3">
          <b>Nome Social:</b>
        </td>
      </tr>
      <tr>
        <td class="pl-3">
          <b>CPF</b>:
          {{ proposalData.driver.taxId }}
        </td>
        <td class="pl-3" colspan="2">
          <b>Data de Nascimento</b>:
          {{
            functions.formataDataHoraPadraoBR(
              proposalData.driver.birthdate,
              false,
            )
          }}
        </td>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Sexo de Nascimento</b>:
          {{ proposalData.driver.gender }}
        </td>
        <td class="pl-3">
          <b>Email</b>:
          {{ proposalData.driver.email }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.MAIN_DRIVER"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.MAIN_DRIVER"
    ></div>
  </vx-card>
</template>

<script>
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractDriver',
  props: {
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    isIndividualPerson(cpf) {
      return cpf.length <= 14 ? true : false;
    },
    getNameLabel(documentId, hasSocialName) {
      if (this.isIndividualPerson(documentId)) {
        return hasSocialName ? 'Nome Social' : 'Nome';
      }
      return 'Razão Social';
    },
  },
  data() {
    return {
      functions,
    };
  },
};
</script>
